module.exports = __webpack_public_path__ + "img/中南大学.d296e967.png";